import React, {useContext, useEffect, useMemo, useState} from 'react';
import {connect} from "react-redux";
import './Calculator.css';
import QuestionsConfig from './QuestionsConfig.js';
import {calculateFootprint, householdCalculation} from './Calculations.js';
import CountrySelectionModal from "../common/CountrySelectionModal";
import {getConfigByMerchantCode} from './merchant-config/merchantConfig';
import {useHistory, useLocation} from "react-router-dom";

import Results from './results/Results'
import CCSlider from './CCSlider';
import NumberPicker from './NumberPicker';
import {Switch, ThemeProvider} from '@material-ui/core';
import {Select} from 'antd';
import {createMuiTheme} from '@material-ui/core/styles';
import {getCountryName} from "../../util/countryCodes";
import {hotjar} from 'react-hotjar';
import * as ccAnalytics from "../../util/analytics/ccAnalytics";
import * as drivingData from '../../util/drivingData';

import PropTypes from "prop-types";
import {bindActionCreators} from 'redux';
import * as personalFootprintActions from "../../redux/actions/personalFootprintActions";
import {buildAnswerObject} from "../../util/personalCalculatorAnswerUtils";
import UserInfoContext from "../../util/UserInfoContext";
import PageHeader from '../PageHeader';
import CountrySelect from "../common/CountrySelect";
import Tooltip from "../Tooltip";
import FooterPanel from "./FooterPanel";
import generatePathWithCurrentMerchantCodeAsBase from "../../util/generatePathWithCurrentMerchantCodeAsBase";
import * as link from "../common/pages";
import {postIframeData} from "../../util/iframePostMessageUtil";
import {getStaticPlanDataByPricingLevel} from "../subscribe-guest/plansData";
import countryData from "../common/impact/data/CountryData";
import {convertToImperialTon} from "../../util/unitConverter";
import {mycc_base_url} from "../../../config";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#2aa43c'
    },
    secondary: {
      main: '#444'
    }
  }
});

//at time of writing, country, userSubscriptions only provided when accessed through logged in view; BUT, it also comes from redux
const Calculator = ({ countryCodeFromRedux, country, savedFootprintData, userSubscriptions, personalFootprintData, actions, currentUserCognito, ...props }) => {
  const location = useLocation();

  const [isShowCountryModal, setShowCountryModal] = useState(false);
  const [questionsConfig, setQuestionsConfig] = useState();
  const [merchantConfig, setMerchantConfig] = useState();
  const [countryCode, setCountryCode] = useState();

  const params = new URLSearchParams(window.location.search)
  const countryWasChangedByUser = params.has("countryChangedByUser")
  const isHideSave = 'true' === params.get("hideSave")
  const isHideHeader = ('true' === params.get("hideHeader")) || merchantConfig?.showHeader===false;

  const {userInfo} = useContext(UserInfoContext);

  const isMyCCDashboard = location.pathname.includes('/my-cc');

  useEffect(() => {
    const referrerMerchantCode = userInfo?.referrerMerchant?.code;
    setMerchantConfig(getConfigByMerchantCode(referrerMerchantCode));
    }, [userInfo]);

  useEffect(() => {
    const newCountryCode = countryWasChangedByUser ? (country || countryCodeFromRedux)
        : (personalFootprintData?.answers?.footprintDataRegionCode || merchantConfig?.countryOverride || country || countryCodeFromRedux);
    setCountryCode(newCountryCode);
  }, [countryCodeFromRedux, country, merchantConfig, personalFootprintData, countryWasChangedByUser]);

  useEffect(() => {
    if(countryCode){
      setQuestionsConfig(new QuestionsConfig(countryCode));
    }
  }, [countryCode]);

  useEffect(() => {
    if (!countryWasChangedByUser && currentUserCognito?.isSignedIn) {
      actions.getAnswersByEmail(currentUserCognito?.authData?.email)
    }
  }, [currentUserCognito])

  useEffect(() => {
    hotjar.initialize(process.env.HOTJAR_SITE_ID, 6);
    ccAnalytics.pageview("/calculator");
  }, []);

  const [footprint, setFootprint] = useState();
  const [footprintOfOneAdult, setFootprintOfOneAdult] = useState();

  const [adults] = useState(1);
  const [children] = useState(0);

  const [carFuel, setCarFuel] = useState('PETROL');
  const [carSize, setCarSize] = useState('MEDIUM');
  const [driving, setDriving] = useState();
  const [diet, setDiet] = useState();
  const [energy, setEnergy] = useState();
  const [waste, setWaste] = useState();

  const [quickFlights, setQuickFlights] = useState(0);
  const [shortFlights, setShortFlights] = useState(0);
  const [intermediateFlights, setIntermediateFlights] = useState(0);
  const [longFlights, setLongFlights] = useState(0);
  
  const [hideRecommendedSubscriptionPanel, setRecommendedSubscriptionPanel] = useState(false);
  const [isRenewableEnergy, setIsRenewableEnergy] = useState(false);
  const [learnMoreModalOpen, setLearnMoreModalOpen] = useState(false);

  const history = useHistory();

  const dashboardUrl = generatePathWithCurrentMerchantCodeAsBase(link.DASHBOARD);
  const subscribeUrl = generatePathWithCurrentMerchantCodeAsBase(link.SUBSCRIBE_GUEST);
  const reductionTipsUrl = (mycc_base_url + '/resources/CarbonClick-ReductionTips.pdf');

  const allAnswers = useMemo(() => {
      return buildAnswerObject({
            adults, children,
            diet,
            energy, currency: questionsConfig?.questions?.energy?.unit, isRenewableEnergy,
            driving, carSize, carFuel,
            waste,
            shortFlights, quickFlights, intermediateFlights, longFlights,
            countryCode, storedCountryCode: countryCodeFromRedux
      });
    }, [questionsConfig, diet, driving, energy, waste, quickFlights, shortFlights, intermediateFlights, longFlights, adults, children, carFuel, carSize, isRenewableEnergy]);

  useEffect(() => {
    if (questionsConfig && diet) {
      setFootprint(calculateFootprint({questions: questionsConfig, answers: allAnswers}));
      setFootprintOfOneAdult(calculateFootprint({questions: questionsConfig, answers: allAnswers, calculateForOneAdult:true}));
    }
  }, [questionsConfig, diet, driving, energy, waste, quickFlights, shortFlights, intermediateFlights, longFlights, adults, children, carFuel, carSize, isRenewableEnergy]);

  useEffect(() => {
    const userAnswers = personalFootprintData?.answers;
    if (userAnswers && userAnswers.type !== 'error' && userAnswers.schemaVersion === 3) {
      // setAdults(userAnswers.HOUSEHOLD.adults)
      // setChildren(userAnswers.HOUSEHOLD.children)
      setCarSize(userAnswers.DRIVING[0].size)
      setCarFuel(userAnswers.DRIVING[0].fuel)
      setQuickFlights(userAnswers.FLIGHTS.numQuick)
      setShortFlights(userAnswers.FLIGHTS.numShort)
      setIntermediateFlights(userAnswers.FLIGHTS.numIntermediate)
      setLongFlights(userAnswers.FLIGHTS.numLong)
      setIsRenewableEnergy(!!userAnswers.ENERGY.hasCarbonNeutralEnergy)
    }
  }, [personalFootprintData])

  useEffect(() => {
    const userAnswers = personalFootprintData?.answers;
    if ((personalFootprintData || countryWasChangedByUser ||!currentUserCognito?.isSignedIn) && questionsConfig) {
      const drivingValue = (userAnswers?.DRIVING ? userAnswers?.DRIVING[0]?.yearlyDistance?.value : null);
      const energyValue = userAnswers?.ENERGY?.monthlySpend?.value;
      setDriving((drivingValue === undefined || drivingValue === null) ? questionsConfig.questions.driving.defaultValue : drivingValue);
      setDiet(userAnswers?.DIET?.yearlyCarbonFootprintOneAdult?.value || questionsConfig.questions.diet.defaultValue);
      setEnergy((energyValue === undefined || energyValue === null) ? questionsConfig.questions.energy.defaultValue : energyValue);
      setWaste(userAnswers?.WASTE?.yearlyProducedOneAdult?.value || questionsConfig.questions.waste.defaultValue);
    }
  }, [personalFootprintData, questionsConfig, currentUserCognito]);

  //tried a few things here and couldn't come up with another way :(
  const handleQuestionChange = (event, value, questionAlias, rootAlias) => {
    switch (rootAlias) {
      case 'DIET': setDiet(value); break;
      case 'DRIVING': setDriving(value); break;
      case 'carType':
        setCarSize(value.split('-')[0]);
        setCarFuel(value.split('-')[1]);
        break;
      case 'ENERGY': setEnergy(value); break;
      case 'WASTE': setWaste(value); break;
    }
  }

  const businessFlightPopoverContent =
    <>
      Do you travel for business? We encourage you to engage with your company about offsetting business travel.<br />Contact CarbonClick if you&apos;d like any more information.
    </>;

  useEffect(() => {
    if (props.userSubscription && props.userSubscription[0] && props.userSubscription[0].id)
      setRecommendedSubscriptionPanel(true);
  }, [props.userSubscription] )

  const sendResultsIFramePostMessage = (eventType) => {
    const footprintInKgs = Object.entries(footprint).reduce((newObj, [key, val]) => {
      newObj[`${key.toLowerCase()}Kg`] = val * 1000;
      return newObj;
    }, {});
    postIframeData({
      type: eventType,
      payload: {
        calculationSchemaVersion: 1,
        allEmissionsKg: totalFootprintOneAdult * 1000,
        emissions: {
          ...footprintInKgs
        }
      }
    });
  }

  const totalFootprintOneAdultWithoutCountryEmissions = !footprintOfOneAdult ? 0 : (footprintOfOneAdult.ENERGY + footprintOfOneAdult.DIET + footprintOfOneAdult.WASTE + footprintOfOneAdult.DRIVING + footprintOfOneAdult.FLIGHTS);
  const totalFootprintOneAdult = !footprintOfOneAdult ? 0 : (totalFootprintOneAdultWithoutCountryEmissions + footprintOfOneAdult.UNAVOIDABLE);

  const getWeightAmountForLocale = (value) => countryData.unitSystem === "IMPERIAL" ? convertToImperialTon(value, 't') : value;

  let oneAdultFootprintForLocaleWithoutCountryEmissions = 
  getWeightAmountForLocale(totalFootprintOneAdultWithoutCountryEmissions).toFixed(1);


  const percentageForSuggestion = ((householdCalculation({
    baseAmount: totalFootprintOneAdult,
    numAdults: adults,
    numChildren: children
  }) / countryData.footprint) * 100);

  let suggestedPlanTier = Math.round(percentageForSuggestion / 50) * 10; // fudge factor to get a good spread of plans suggested
  suggestedPlanTier = suggestedPlanTier < 10 ? 10 : (suggestedPlanTier > 40 ? 40 : suggestedPlanTier);
  const suggestedPlanData = getStaticPlanDataByPricingLevel(Math.min(40, suggestedPlanTier));

  const offsetButtonClicked = () => {
    if (merchantConfig?.offsetAction === "IFRAME_POST_MESSAGE") {
      sendResultsIFramePostMessage('POST_PERSONAL_CALCULATOR_RESULT');
    } else {
      const avgFootprintByCountryParam = oneAdultFootprintForLocaleWithoutCountryEmissions
          ? `&carbonAmountTonnes=${oneAdultFootprintForLocaleWithoutCountryEmissions}`
          : '';
      history.push(`${subscribeUrl}?recommendedPricingLevel=${suggestedPlanData && suggestedPlanData.pricingLevel}${avgFootprintByCountryParam}`);
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <main className={`cc-main-content ${!currentUserCognito?.isSignedIn && 'bg-gradient-accent-light'}`}>
        {!isHideHeader &&
          <PageHeader
            title={"My Carbon Footprint"}
          />
        }
        <article className={`personal-calculator-article w-fit my-4 ${isMyCCDashboard ? 'mx-initial' : 'mx-auto'}`}>
          <div className='personal-calculator'>
          <div className="" style={{marginBottom: 15 }}>
            {countryCode && <Results savedFootprint={personalFootprintData?.answers} modalOpen={learnMoreModalOpen} setModalOpen={setLearnMoreModalOpen} answers={allAnswers} unavoidableCountryEmissionsPerPerson={questionsConfig?.questions.unavoidableCountryEmissions.multiplier} footprintHousehold={footprint} footprintOfOneAdult={footprintOfOneAdult} numberOfAdults={adults} numberOfChildren={children} countryCode={countryCode} hideRecommendedPanel={hideRecommendedSubscriptionPanel} merchantConfig={merchantConfig} isHideSave={isHideSave}></Results>}
          </div>
          <div className="border-light App-main">
            {diet && <div className="main-pane">
              {!merchantConfig?.countryOverride && countryCode &&<div className="flights-section cc-question">
                <div className='cc-question-title'>LOCATION</div>
                <div className='cc-question-description'>
                  In which country do you live?
                </div>
                <div style={{paddingLeft: '15px'}}>
                  <CountrySelect
                      showInline
                      country={countryCode}
                      userSubscriptions={userSubscriptions}
                      setShowModal={setShowCountryModal}
                      displayBasedOnView
                  />
                  {questionsConfig.isUnsupportedCountry &&
                    <p className='color-primary m-0 font-sm mt-2'> Our calculator isn&apos;t yet optimised for {getCountryName(countryCode)}, so we&apos;ll use EU data for now! </p>
                  }
                </div>
              </div>}
            <CCSlider style={{ paddingBottom: '1rem' }} value={driving} onChange={handleQuestionChange} questionConfig={questionsConfig.questions.driving}>
              <Select
                  className='common-select'
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={carSize + '-' + carFuel}
                  onChange={(event, value) => handleQuestionChange(event, value.value,'carType', 'carType')}
                  >
                    <>
                    {drivingData.vehicleTypes.map(type=> ( <Select.Option key={type.code()} value={type.code()}>{type.displayName()}</Select.Option> ))}
                    </>
                </Select>
            </CCSlider>
            <div className="flights-section cc-question">
              <div className='cc-question-title'>FLIGHTS <Tooltip color={'var(--primary-color)'} content={'Please do not include business flights. A return flight counts as single flight.'}/></div>
              <div className='cc-question-description'>
                In the last year, excluding
                {' '}<a>business</a>{' '}
                travel
              </div>
              <NumberPicker value={quickFlights} onChange={(val) => setQuickFlights(val)} questionConfig={questionsConfig.questions.quickFlights} />
              <NumberPicker value={shortFlights} onChange={(val) => setShortFlights(val)} questionConfig={questionsConfig.questions.shortFlights} />
              <NumberPicker value={intermediateFlights} onChange={(val) => setIntermediateFlights(val)} questionConfig={questionsConfig.questions.intermediateFlights} />
              <NumberPicker value={longFlights} onChange={(val) => setLongFlights(val)} questionConfig={questionsConfig.questions.longFlights} />
            </div>
          </div>}
          {diet && <div className="main-pane" style={{ marginBottom: 15 }}>
            <CCSlider style={{ paddingBottom: '1rem' }} value={diet} onChange={handleQuestionChange} questionConfig={questionsConfig.questions.diet}></CCSlider>
            <CCSlider isChildrenAfter={true} style={{marginBottom: '68px', paddingBottom: '1rem'}} value={energy} onChange={handleQuestionChange} questionConfig={questionsConfig.questions.energy}>
              <div style={{width: '100%', float: 'left', marginLeft: '-8px'}} className='d-flex pt-1'>
                <Switch
                    className={isRenewableEnergy ? 'cc-switch-active' : 'cc-switch-inactive'}
                    selected={isRenewableEnergy}
                    onChange={(e) => {setIsRenewableEnergy(e.target.checked)}}
                />
                <div style={{paddingTop: '7px'}} className='font-bold cc-question-description pl-2'>I purchase carbon neutral energy</div>
              </div>
            </CCSlider>
            <CCSlider style={{ paddingBottom: '1rem' }} value={waste} onChange={handleQuestionChange} questionConfig={questionsConfig.questions.waste}></CCSlider>
          </div>}
        </div>
        </div>
      </article>
      <div style={{backgroundColor: currentUserCognito?.isSignedIn ? 'var(--accent-light-color)' : ''}}>
        <div
          className={`personal-calculator-article w-fit mt-3 calculator-footer-panels-container my-4 ${isMyCCDashboard ? 'mx-initial' : 'mx-auto'}`}
        >
          <FooterPanel
              title={'What’s a carbon footprint?'}
              imgUrl={'https://res.cloudinary.com/carbonclick/image/upload/w_100/e_colorize,co_rgb:322A29/v1698749204/Emails/co2-icon_cehcvn.png'}
              imgStyle={{width: '41px', height: '19px'}}
              description={'Learn what carbon emissions are and how your footprint is calculated.'}
              buttonText={'Learn more'}
              onButtonClick={() => {setLearnMoreModalOpen(true)}}
          />
          <FooterPanel
              title={'How can I reduce my footprint?'}
              imgUrl={'https://res.cloudinary.com/carbonclick/image/upload/w_100/e_colorize,co_rgb:322A29/v1698749210/Emails/smile-icon_faks2x.png'}
              imgStyle={{width: '31px', height: '23px'}}
              description={currentUserCognito?.isSignedIn ? 'Check out our climate action tips on the dashboard for ways to reduce your personal carbon footprint.' : 'Check out our climate action tips for ways to reduce your personal carbon footprint.'}
              buttonText={currentUserCognito?.isSignedIn ? 'Go to dashboard' : 'View tips'}
              onButtonClick={() => {currentUserCognito?.isSignedIn ? history.push(dashboardUrl) : window.open(reductionTipsUrl, '_blank')}}
          />
          <FooterPanel
              title={'Offset my footprint'}
              imgUrl={'https://res.cloudinary.com/carbonclick/image/upload/w_100/e_colorize,co_rgb:322A29/v1708195690/MyCC/planet_da4xwt.png'}
              imgStyle={{width: '32px', height: '32px'}}
              description={'Support meaningful projects around the globe to offset your carbon footprint.'}
              buttonText={'Offset now'}
              onButtonClick={offsetButtonClicked}
          />
        </div>
      </div>
      <CountrySelectionModal
        showModal={isShowCountryModal}
        myLocation="/calculator"
        setLocationModalVisible={setShowCountryModal}
      />
    </main>

    </ThemeProvider>
  );
}

function mapStateToProps(state) {
  return {
    countryCodeFromRedux: state.countryResult && state.countryResult.country,
    userSubscription: state.subsList,
    personalFootprintData: state.personalFootprintData,
    currentUserCognito: state.currentUserCognito,
    savedFootprintData: state.personalFootprintData
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: {
    getAnswersByEmail: bindActionCreators(
      personalFootprintActions.getPersonalFootprint,
      dispatch
    )
  }
});

Calculator.propTypes = {
  country: PropTypes.string
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Calculator);